import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  canViewNoteSelection,
  getNoteSelectionCopyText,
  openNoteSelectionView,
} from '../utils/noteSelectionActions';

export type NoteSelectionAnchor = {
  text: string;
  top: number;
  left: number;
};

type NoteSelectionActionPopupProps = {
  selection: NoteSelectionAnchor;
  onClose: () => void;
};

export const NoteSelectionActionPopup: React.FC<NoteSelectionActionPopupProps> = ({
  selection,
  onClose,
}) => {
  const { t } = useTranslation();
  const showView = canViewNoteSelection(selection.text);
  const copyLabel = t('common.copy', { defaultValue: 'Copy' });
  const viewLabel = t('common.view', { defaultValue: 'View' });

  return (
    <Box
      sx={{
        position: 'absolute',
        top: Math.max(selection.top, 8),
        left: `clamp(8px, calc(${selection.left}px - ${showView ? 96 : 48}px), calc(100% - ${showView ? 200 : 104}px))`,
        transform: 'translateY(calc(-100% - 10px))',
        zIndex: 2,
        display: 'flex',
        gap: 0.5,
        boxShadow: 3,
      }}
    >
      <Button
        size="small"
        variant="contained"
        startIcon={<ContentCopyIcon fontSize="small" />}
        onMouseDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          void navigator.clipboard.writeText(getNoteSelectionCopyText(selection.text));
          onClose();
        }}
        sx={{ minWidth: 80, textTransform: 'none' }}
      >
        {copyLabel}
      </Button>
      {showView && (
        <Button
          size="small"
          variant="contained"
          color="secondary"
          startIcon={<VisibilityIcon fontSize="small" />}
          onMouseDown={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            openNoteSelectionView(selection.text);
            onClose();
          }}
          sx={{ minWidth: 80, textTransform: 'none' }}
        >
          {viewLabel}
        </Button>
      )}
    </Box>
  );
};
